import { render, staticRenderFns } from "./ContentCategories.vue?vue&type=template&id=8eaa4f56&scoped=true"
import script from "./ContentCategories.vue?vue&type=script&lang=js"
export * from "./ContentCategories.vue?vue&type=script&lang=js"
import style0 from "./ContentCategories.vue?vue&type=style&index=0&id=8eaa4f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaa4f56",
  null
  
)

export default component.exports